import React, { Component } from 'react'
import { connect } from 'react-redux'
import SmallSearch from './search/SmallSearch'
import {Dropdown} from 'components/basic'

class Header extends Component {
  constructor (props) {
    super(props)
    this.state = {
      toggled: false
    }
  }
  toggleSidebarState () {
    this.props.dispatch({
      type: 'SET_SIDEBAR_STATE',
      payload: !this.props.sidebar
    })
  }
  toggleToolbarState () {
    this.props.dispatch({
      type: 'SET_TOOLBAR_STATE',
      payload: !this.props.toolbar
    })
  }
  render () {
    return (
      <nav className='navbar navbar-fixed-top navbar-default'>
        <div className='container-fluid'>
          <div className='navbar-header'>
            <a className='navbar-brand'><img src='/static/flowlogo.svg' width='40' height='40' /><span style={{fontSize: 20}}>Flow <small style={{fontSize: 10}}>{this.props.siteReducer.user.providerName}</small></span></a>
          </div>
          <ul className='nav navbar-nav navbar-nav-first'>
            <li>
              <a className='header-button' onClick={(e) => this.toggleSidebarState()}><i className='fa fa-bars' /></a>
            </li>
          </ul>
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a className='header-button' onClick={(e) => this.setState({toggled: !this.state.toggled})}><i className='fa fa-user' /> {this.props.siteReducer.user.name}</a>
            </li>
            <div className={(this.state.toggled ? 'dropdown-overlay' : 'hidden')} onClick={() => this.setState({toggled: !this.state.toggled})}>
              <div className='dropdown-links header-dropdown'>
              <ul>
                <li className={(this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'auth' && endpoint.version === '2.4').length !== 0 ? '' : 'hidden')}>
                  <a onClick={e => window.location.hash = '/users/' + this.props.siteReducer.user.userId}><i className='fa fa-fw fa-wrench' /> Account</a>
                </li>
                <li>
                  <a onClick={e => {
                    window.localStorage.clear()
                    window.location.reload()
                  }}>
                  <i className='fa fa-fw fa-sign-out' /> Log out</a>
                </li>
              </ul>
              </div>
            </div>
          </ul>
          <SmallSearch />
        </div>
      </nav>
    )
  }
}
// eslint-disable-next-line
Header = connect(state => state)(Header)
export default Header



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/core/Header.js